import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Privileges',
  basePath: '/privileges',
  columns: [
    { key: 'privilege', label: 'Privilege', sortable: true },
  ],
  fields: [
    { key: 'privilege', label: 'Privilege', type: 'text', required: true },
  ],
});
